export default "__VITE_ASSET__exkHOY83__"